/**
 *
 * Draws sphere with timeline and mapGrid of
 * Bauprozess map project timeline
 *
 * Documentation on: https://gitlab.ethz.ch/sherms/map/-/wikis/Sphere
 *
 * authored by susanne herms @ ethz darch menz 2022
 */

let sphere;
let timeline;
let space;
let grid;
let mainIndex = 10; // index 10 - Strategie isMain

const LINE_DASH = [1,2]; //[4, 3];
const ALPHA = 0.18; // main angle for latitudes;
const SPHERE_OFFSET = 30;
const DURATION = 20; // duration of animation: 60s/15

const dark = "#101010"; // map background
const dark2 = "#252525"; // radial gradient ot map background
const ethOrange = '#ff5900';
const ethDark20 = '#3a3a3a';
const ethDark = '#575757';
const ethGray = '#6F6F6F';
const ethGray80 = '#8c8c8c';
const ethGray60 = '#a9a9a9';
const ethGray40 = "#c5c5c5";
const lightBlue = '#5F6F6F';
const darkBlue = '#475757';
let sections = {};

const MAP_MODES = ['sphere', 'list', 'table', 'target'];
let currentMode = 'sphere'; // initial mode

(function($){
    $(function($) {
        const isExternal = document.referrer.split("/")[2] !== window.location.href.split("/")[2];
        if (isExternal) {
            resetMapMode();
        }
        let largeDetector = $('.media-detector .large');
        let largeViewport = largeDetector.is(':visible');
        if (largeViewport) {
            const mode = localStorage.getItem('map.navigator.mode') || 'sphere';
            if (localStorage.getItem('map.navigator.mainIndex')) {
                mainIndex = parseInt(localStorage.getItem('map.navigator.mainIndex'), 10);
            }
            changeMapMode(mode);
        }

        window.addEventListener("resize", () => {
            // change map-mode on resize
            if (largeViewport && ! largeDetector.is(':visible')) {
                if (currentMode !== 'list') {
                    changeMapMode('list', true);
                }
                largeViewport = false;

            } else if (!largeViewport && largeDetector.is(':visible')) {
                changeMapMode(currentMode, true);
                largeViewport = true;
            } else {
                initSphereMode();
            }
        });

        $('#map-list').on("click contextmenu", 'a', function(e) { // redirecting on target mode
            if (currentMode === 'target' && e.currentTarget) {
                e.currentTarget.href = e.currentTarget.href.replace('/artikel/', '/target/');
            }
        });
        window.addEventListener('keydown', function(event) {
            if (currentMode === 'sphere' || currentMode === 'target') {
                if (event.key === 'ArrowLeft') {
                    navigateSphere(false);
                } else if (event.key === 'ArrowRight') {
                    navigateSphere(true);
                }
            }
        });
    })
})(jQuery);

/** NAVIGATOR **/
changeMapMode = function(mode, forced) {
    if (!forced) { // forced by viewport change
        currentMode = mode;
    }

    MAP_MODES.map(name => {
        $('#map-' + name).hide();
        $('.active-mode-' + name).hide();
        $('.button-' + name).removeClass('active');
        $('#navigator').removeClass('on-' + name);
    });

    if (mode === 'target') {
        $('#map-list').addClass('target-mode');
        $('#map-list').show();
        $('#navigator').addClass('on-list');
    } else {
        $('#map-list').removeClass('target-mode');
        $('#map-' + mode).show(); // template id of mode
        $('#navigator').addClass('on-' + mode);
    }

    $('.active-mode-' + mode).show(); // shows icon in tool-box-header
    $('.button-' + mode).addClass('active');  // button in tool-box-content

    if (mode === 'table') {
        $('#navigator').hide();
        $('#menu-trigger').addClass('closed');
    }
    initSphereMode();
    revokeHelp(); // -> frontend/help.js

    $(window).scrollTop(0);
    localStorage.setItem('map.navigator.mode', mode);
}

/** INIT **/
initSphereMode = function() {
    if ($('#sphere') && $('#sphere').is(':visible')) {

        sphere = new Sphere('#sphereScene');
        initStyleProperties();

        space = new Space('#spaceScene');
        timeline = new Timeline('#timelineScene');
        grid = new MapGrid('#map-grid');

        $( '#sphereScene, #map-grid' ).on( "mousemove touchmove", function(e)  { sphere.handle_mousemove(e)});
        $( '#sphereScene, #map-grid' ).on( "mousedown touchstart", function(e)  { sphere.handle_mousedown(e)});
        $( '#sphereScene, #map-grid' ).on( "mouseup touchend", function(e)  { sphere.handle_mouseup(e)});


    }
}
initStyleProperties = function() {
    sections = {
        'sphereOffset': (SPHERE_OFFSET).toString(),
        'section1': (SPHERE_OFFSET + sphere.radius - sphere.longitudes[2]).toString(),
        'section2': (SPHERE_OFFSET + sphere.radius - sphere.longitudes[1]).toString(),
        'sectionHalf': (SPHERE_OFFSET + sphere.radius).toString(),
        'section3': (SPHERE_OFFSET + sphere.radius + sphere.longitudes[1]).toString(),
        'section4': (SPHERE_OFFSET + sphere.radius + sphere.longitudes[2]).toString(),
        'sectionFull': (SPHERE_OFFSET + 2 * sphere.radius).toString(),
    };

    let root = document.documentElement;
    for (const key in sections) {
        root.style.setProperty('--' + key, sections[key] + 'px');
    }
    root.style.setProperty('--colorLight', ethGray40);
    root.style.setProperty('--duration', (1000/60 * DURATION) + 'ms');
}

/** HELP FUNCTIONS **/
loopArray = function(array, positiv, jumpIndex = null) { // this index defines position of the timeline
    const index = jumpIndex || (positiv ? 1 : 10);
    const splicedEnd = array.splice(index);
    return splicedEnd.concat(array);
}
updateMainIndex = function(positiv) {
    if (positiv) {
        mainIndex = mainIndex === 10 ? 0 : mainIndex + 1;
    } else {
        mainIndex = mainIndex === 0 ? 10 : mainIndex - 1;
    }
}
initPhpIndex = function(phpIndex) {
    let index = phpIndex - 2;
    if (index < 1) {
        index = 11 + index;
    }
    mainIndex = index;
    localStorage.setItem('map.navigator.mainIndex', mainIndex);
    window.host
}
navigateSphere = function(direction) {
    updateMainIndex(direction);
    timeline.loop(direction)
    grid.loop(direction);
    grid.animate(direction);
    sphere.animate(direction);
    timeline.animate(direction);
    localStorage.setItem('map.navigator.mainIndex', mainIndex);
}
isEndOfCycle= function(index) {
    return ((mainIndex === 0 && index === 0) || mainIndex + index === 11);

}

/** SPHERE **/
Sphere = function(selector) {
    this.container = document.querySelector('#sphere');
    this.canvas = document.querySelector(selector);
    this.position = document.querySelector('#sphere').getBoundingClientRect();
    this.ctx = this.canvas.getContext('2d');
    this.init();
}
Sphere.prototype = {

    init: function() {

        this.width = this.canvas.width = this.container.clientWidth;
        this.height = this.canvas.height = this.container.clientHeight;

        this.radius = Math.floor(Math.min(this.width, (this.height))/2 - SPHERE_OFFSET);
        this.moveX = Math.floor(this.radius + SPHERE_OFFSET);
        this.moveY = Math.floor(this.height/2 + SPHERE_OFFSET);
        this.ctx.translate(this.moveX, this.moveY);
        this.ctx.strokeStyle = ethGray40;
        this.ctx.fillStyle = ethGray40;
        this.longitudes = [];
        [0,1.5,3].forEach(long => {// for harmonic division of the sections.
            this.longitudes.push(Math.floor(this.radius * (Math.sin(long/10 * Math.PI))));
        });
        this.draw();
    },
    clear: function() {
        this.ctx.clearRect(this.moveX, this.moveY, this.width, this.height);
    },
    draw: function(animationStep = 0, positiv = true) {

        if (this.radius < 1) {
            return; // to prevent rendering errors on negativ radius
        }
        this.clear();

        /* planet-circle */
        this.drawCircle(dark);
        this.drawLongitudes(animationStep, positiv);
        this.drawShadows();

        if (animationStep && animationStep < DURATION) {
            window.requestAnimationFrame(() => {
                this.clear();
                this.draw(animationStep + 1, positiv);
            });
        } else if (animationStep && animationStep === DURATION) {
            this.clear();
            this.draw(); // redraw initial sphere
        }

        // this.drawCircle();
    },
    animate: function(direction) {
        window.requestAnimationFrame(() => {
            this.draw(1, direction);
        });
    },
    drawLongitudes: function(animationStep, positiv) {
        this.longitudes.forEach((y_radius, i) => {

            let next = this.longitudes.length === i + 1 ? this.radius - this.longitudes[i] :
                this.longitudes[i + 1] - this.longitudes[i];
            let previous = this.longitudes.length === i + 1 ? this.radius : this.longitudes[i + 1];

            let ry_left = animationStep ? y_radius + (animationStep * next / DURATION) : y_radius;
            let ry_right = animationStep ? previous - (animationStep * next / DURATION) : y_radius;

            if (!positiv) {
                const swap = ry_left;
                ry_left = ry_right;
                ry_right = swap;
            }

            let style = i === 0 ?
                { dashed: [0.8, 3], color: ethGray60} :
                { dashed: LINE_DASH, color: ethGray40}

            style.color = !animationStep && this.highLightColor(i, true) || style.color;
            //s_ang & e_ang: start and end angle offset from sphere, stroke does not overlap with sphere at pole
            this.drawArc(ry_left, Math.PI / 2, style); // left sphere
            if ( i > 0 || animationStep) { // centered longitude draw only once
                style.color = !animationStep && this.highLightColor(i, false) || ethDark;
                this.drawArc(ry_right, Math.PI * 1.5, style); // right sphere
            }
        });
    },
    drawShadows() {
        this.ctx.globalCompositeOperation = "source-atop"; // draws only intersection with sphere
        this.drawShadow(this.radius, 0, this.radius/3, this.radius, 0); // right side outer
        this.drawShadow(this.radius, 0, this.radius/4, this.radius, 0); // right side inner
        this.drawShadow(this.radius/4, this.radius, this.radius, this.radius/2,
            -Math.PI/8); // South Pole outer
        this.drawShadow(this.radius/4, this.radius, this.radius, this.radius/3,
            -Math.PI/6, {alpha: 0.9}); // South Pole inner
        this.ctx.globalCompositeOperation = "source-over"; // reset to default
    },

    drawArc: function(ry, rot, style) {
        this.ctx.save();
            this.ctx.beginPath();
            this.ctx.ellipse(0, 0, this.radius,
                Math.floor(ry), rot,
                Math.PI/30, Math.PI - Math.PI/30);
            this.ctx.strokeStyle = style.color;
            this.ctx.setLineDash(style.dashed);
            this.ctx.stroke();
        this.ctx.restore();
    },
    drawCircle: function(fill = false) {
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.ellipse(0, 0, this.radius, this.radius, 0, 0, 2 * Math.PI);
        if (fill) {
            this.ctx.fillStyle = fill;
            this.ctx.fill();
        }
        this.ctx.stroke();
        this.ctx.restore();
    },
    drawShadow: function(x,y, rx, ry, rot, style) {
        this.ctx.save();
            this.ctx.beginPath()
            this.ctx.ellipse(Math.floor(x), Math.floor(y), Math.floor(rx), Math.floor(ry),
                (rot || 0),
                0,
                2 * Math.PI);
            this.ctx.fillStyle = style?.color ? style.color : dark;
            this.ctx.globalAlpha = style?.alpha? style.alpha : 0.6;
            this.ctx.fill();
        this.ctx.restore();
    },

    highLightColor: function(i, left) {

        if ( i === 2 ) {
            if (mainIndex == 0 && left || mainIndex == 7 && !left) {
                return ethOrange;
            }
        }
        if ( i === 1) {
            if (mainIndex == 10 && left || mainIndex == 8 && !left) {
                return ethOrange;
            }
        }
        if (i === 0 && mainIndex == 9) {
            return ethOrange;
        }
        return false;
    },
    convertPosition: function(e) {
        // translate the event to the canvas-relative position
        const pageX = e.pageX || e.originalEvent.touches[0].pageX;
        const pageY = e.pageY || e.originalEvent.touches[0].pageY;
        return [pageX - this.position.left, this.width - pageY + this.position.top];
    },
    handle_mousemove: function(e) {
        if (this.downPos) {
            this.upPos = this.convertPosition(e);
            let distance = Math.floor(this.downPos[0] - this.upPos[0]);
            if (Math.abs(distance) > this.threshold) {
                this.threshold += Math.floor(this.radius/4);
                navigateSphere(distance > 0);
            }
        }
    },
    handle_mousedown: function(e) {
        $('#sphere, #map-grid').addClass('grabbing');
        this.downPos = this.convertPosition(e);
        this.threshold = Math.floor(this.radius/8);
    },
    handle_mouseup: function() {
        $('#sphere, #map-grid').removeClass('grabbing');
        this.downPos = null;
    },
}

/** TIMELINE **/
Timeline = function(selector) {
    this.canvas = document.querySelector(selector);
    this.timelineItems = Array.prototype.slice.call(document.querySelectorAll('#timeline a'),0);
    this.timelineAngles = []; // array of angle-positions on timeline ellipse
    this.timelinePositions = [];
    this.initTimelineAngles();
    this.initTimelinePositions();
    this.init();
}
Timeline.prototype = {
    init: function() {
        this.ctx = this.canvas.getContext('2d');
        this.width = this.canvas.width = sphere.width;
        this.height = this.canvas.height = sphere.height;
        this.ctx.translate(sphere.moveX, sphere.moveY);
        if (sphere.radius < 1) {
            return;
        }
        const offset = 8; // moving ellipse down, stroke should not overlap with sphere at 0 and 180 degrees
        const latitude = Math.PI / 4;
        this.ellipse = {
            rx: Math.floor(sphere.radius * Math.cos(latitude)),
            ry: Math.floor(sphere.radius * Math.cos(latitude) * Math.sin(ALPHA)),
            cy: Math.floor(-sphere.radius * Math.sin(latitude) + offset),
        }
        this.draw();
    },
    initTimelineAngles: function() {
        // render front angles on ellipse - points marking intersection with longitude - **COUNTERCLOCKWISE From 180 - 0 - 180!**
        const rearAngles = [];
        [1.5, 3, 0, 1.5, 3].forEach((num, i) => {
            let offset = 0.03;
            if (i > 2) {
                this.timelineAngles.push((Math.PI/2) / num - offset);
                rearAngles.push(Math.PI + this.timelineAngles[this.timelineAngles.length - 1]); // rear
            } else if (num === 0) {
                this.timelineAngles.push(Math.PI/2); // 45 deg or center longitude of sphere
                rearAngles.push(Math.PI + (Math.PI/2) / 0.9); // additional rear
                rearAngles.push(2* Math.PI - (Math.PI/2) / 0.9); // additional rear
            } else {
                this.timelineAngles.push(Math.PI/2 + (Math.PI/2) / num + offset);
                rearAngles.push(Math.PI + this.timelineAngles[this.timelineAngles.length - 1]); // rear
            }
        });
        this.timelineAngles.push(0); // right
        this.timelineAngles = this.timelineAngles.concat(rearAngles);
        this.timelineAngles.push(Math.PI); // left
    },
    initTimelinePositions: function() {
        for (let i = 1; i <= 5; i++ ) { // render front positions on ellipse
            // front has five items, reverse direction from Math.PI to 0 (180 - 0)
            this.timelinePositions.push(Math.PI - i * Math.PI/5);
        }
        for (let i = 1; i <= 6; i++ ) { // render rear position and angle on ellipse
            // rear has six items, reverse direction from 2*Math.PI to Math.PI (360 -0)
            this.timelinePositions.push(2 * Math.PI - i * Math.PI/6 );
        }
        if (mainIndex !== 0) {
            this.timelineItems = loopArray(this.timelineItems, false, mainIndex);
        }
    },

    clear: function() {
        this.ctx.clearRect(-sphere.moveX, -sphere.moveY, sphere.width, sphere.height);
    },
    draw: function(animationStep = 0, positiv = false) {
        this.drawArc(this.ellipse, Math.PI/2, Math.PI, ethGray40); // front-timeline left
        this.drawArc(this.ellipse, 0, Math.PI/2, ethGray80); // front-timeline right
        this.drawArc(this.ellipse, Math.PI, 2 * Math.PI, ethDark20, LINE_DASH); // rear-timeline
        this.timelineAngles.forEach((position, i) => {
            let distance;
            if (this.timelineAngles.length === i + 1 ) {
                distance = this.timelineAngles[i] - this.timelineAngles[0]; // take first to calculate distance
            } else if (this.timelineAngles[i] === 0) {
                distance =  2 * Math.PI - this.timelineAngles[i + 1]; // for angle 0 we take 360
            } else {
                distance =  Math.max(this.timelineAngles[i + 1] - this.timelineAngles[i],
                    this.timelineAngles[i] - this.timelineAngles[i + 1]); // we take the positiv value
            }

            let angle = animationStep ? position +  (animationStep * distance / DURATION) : position;
            if ( !positiv ) {
                angle = animationStep ? position - (animationStep * distance / DURATION) : position;
            }

            const x_dot = this.ellipse.rx * Math.cos(angle);
            const y_dot = this.ellipse.ry * Math.sin(angle) + this.ellipse.cy;
            const isRear = angle > Math.PI;

            if (isEndOfCycle(i) && !isRear) { // dotted line between Bauwerkserhaltung und Strategie
                this.drawArc(this.ellipse, angle - 0.15, angle + 0.15, dark, [4, 3])
            }
            this.drawMarker(x_dot,y_dot, isRear, i);
        });
        if (!animationStep || animationStep === 1) {
            this.drawItems();
        }
        if (animationStep && animationStep < DURATION) {
            window.requestAnimationFrame(() => {
                this.clear();
                this.draw(animationStep + 1, positiv);
            });
        } else if (animationStep && animationStep === DURATION) {
            this.clear();
            this.draw(); // redraw initial sphere
        }
    },
    drawItems: function() {
        $('#timeline-main-article')[0].style.top = (53 + sphere.moveY - sphere.radius) + 'px';
        $('#timeline-main-article a').addClass('ready');

        this.timelinePositions.forEach((angle, i) => {
            const x_pos = (this.ellipse.rx) * Math.cos(this.timelinePositions[i]);
            const y_pos = (this.ellipse.ry) * Math.sin(this.timelinePositions[i]) + this.ellipse.cy;
            const isRear = angle > Math.PI;
            let positionClasses = isRear ? ' rear' : ' front';
            positionClasses += angle === Math.PI ? ' left' : angle === 0 ? ' right' : '';
            positionClasses += i === 1 ? ' isMain' : '';
            if (this.timelineItems[i]) {
                this.timelineItems[i].classList = positionClasses + ' ready';
                this.timelineItems[i].style.top = (sphere.moveY + Math.floor(y_pos)) + 'px';
                this.timelineItems[i].style.left = (sphere.moveX + Math.floor(x_pos)) + 'px';
            }
        });
    },
    drawArc: function(ellipse, s_ang, e_ang, color, dashed = false) {
        this.ctx.save();
        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = color;
        if (dashed) {
            this.ctx.setLineDash(dashed);
        }
        this.ctx.beginPath();
        this.ctx.ellipse(0, ellipse.cy, ellipse.rx, ellipse.ry, 0, s_ang, e_ang);
        this.ctx.stroke();
        this.ctx.restore();
    },
    drawMarker: function(x, y, isRear, index) {
        this.ctx.save();
        this.ctx.fillStyle = isRear ? ethDark20 : (index > 2 ? ethGray80 : ethGray40);
        const r = isRear ? 4 : 6;
        this.ctx.beginPath();
        this.ctx.ellipse(Math.floor(x), Math.floor(y), r, r, 0, 0, 2 * Math.PI);
        this.ctx.fill();
        this.ctx.restore();
    },
    animate: function(direction) {
        window.requestAnimationFrame(() => {
            this.draw(1, direction);
        });
    },
    loop: function(positiv) {
        this.timelineItems = loopArray(this.timelineItems, positiv);
    }
}

/** SPACE **/
Space = function(selector) {
    this.spaceItems = Array.prototype.slice.call(document.querySelectorAll('#space a'),0);
    this.canvas = document.querySelector(selector);
    this.ctx = this.canvas.getContext('2d');
    this.init();
}
Space.prototype = {
    init: function() {
        this.container = document.querySelector('.central-content-pane').getBoundingClientRect();
        this.sphereWrapper = document.querySelector('.sphere-wrapper').getBoundingClientRect();
        this.width = this.canvas.width = this.container.width;
        this.height = this.canvas.height = this.container.height - 20;
        this.draw();
    },
    draw: function() {
        if (sphere.radius < 1) {
            return;
        }

        this.drawBg(this.sphereWrapper.left, this.sphereWrapper.top, sphere.radius);

        const offsetToSphere = sphere.moveY - sphere.radius; // how much space is on top of the sphere ?
        this.isShort = offsetToSphere < 80;
        this.isMedium = offsetToSphere < 110 && !this.isShort;

        this.unit = Math.floor(sphere.radius/4);
        const sphereLeftCorner = this.sphereWrapper.width + this.sphereWrapper.left;
        const sphereCenter = this.sphereWrapper.y + window.scrollY + sphere.moveY;
        this.centerX = sphereLeftCorner + 2*this.unit;
        this.centerY = sphereCenter + 2*this.unit;

        this.ctx.fillStyle = lightBlue;
        this.ctx.strokeStyle = lightBlue;

        const orbitConstants = this.isShort ? [13, 13.5, 14] : [13, 13.7, 14.4];
        orbitConstants.map( (orbit, i) => {
            const rx = orbit * this.unit;
            const ry = orbit * 0.42 * this.unit; // proportional constant rx:ry = 0.42
            this.drawOrbit( rx, ry, Math.PI/9, i); // 0: Gesellschaft, 1: Wirtschaft, 2: Umwelt
        })

        for (let y = 0; y < this.height; y += 5) {
            for (let x = 0; x < this.width; x += 5) {
                if (Math.random() > 0.98) {
                    this.drawStar(x,y);
                }
            }
        }
    },
    drawBg: function(x, y, r) {
        this.ctx.save();
        const grd = this.ctx.createRadialGradient(x + r, y + r, r, x + r, y + r, 3/2*r);
        grd.addColorStop(0, dark2);
        grd.addColorStop(0.9, dark);
        this.ctx.fillStyle = grd;
        this.ctx.fillRect(0, 0, this.width, this.height);
        this.ctx.restore();
    },
    drawStar: function(x,y) {
        const size = 1.5*(Math.random());
        this.ctx.fillStyle = Math.random() > 0.5 ? lightBlue : darkBlue;
        this.ctx.beginPath();
        this.ctx.ellipse(x, y, size, size, 0, 0, 2 * Math.PI);
        this.ctx.fill();
    },
    drawOrbit: function(rx, ry, rot, index) {
        const x = this.centerX;
        const y = this.centerY;
        this.ctx.beginPath();
        this.ctx.ellipse(x, y, 3, 3, 0, 0, 2 * Math.PI);
        this.ctx.fill();
        this.ctx.beginPath();
        this.ctx.ellipse(x, y, Math.floor(rx), Math.floor(ry), rot, 0, 2 * Math.PI);
        this.ctx.stroke();
        if (index === 0) { // inner most orbit
            this.drawMarker(x, y, rx, ry, rot, index, Math.PI + Math.PI / 3); // Gesellschaft
            if (this.isMedium) {
                this.drawMarker(x,y,rx,ry, rot, 2, Math.PI + Math.PI/4.7); // Umwelt on isMedium
            } else if (this.isShort) {
                this.drawMarker(x,y,rx,ry, rot, 2, Math.PI + Math.PI/4.7); // Umwelt on isShort
                this.drawMarker(x, y, rx, ry, rot, 1, Math.PI + Math.PI/3.7); // Wirtschaft on isShort
            }
        } else if (index === 1 && !this.isShort) {
            this.drawMarker(x, y, rx, ry, rot, index, Math.PI + Math.PI/3.4); // Wirtschaft
        } else if (index === 2 && !this.isShort && !this.isMedium) { // furthest orbit
            this.drawMarker(x, y, rx, ry, rot, 2, Math.PI + Math.PI/3.9); // Umwelt
        }
    },
    drawMarker: function(cx,cy, rx, ry, rotation, index, a) {
        const alpha = a || Math.PI + Math.PI/6;
        const x1 = cx + rx * Math.cos(alpha);
        const y1 = cy + ry * Math.sin(alpha);

        // how to getPointOnEllipse https://stackoverflow.com/a/57366972 --- Lucky me :-))
        const cosA = Math.cos(rotation);
        const sinA = Math.sin(rotation);
        const dx = x1 - cx;
        const dy = y1 - cy;
        const x = cx + dx * cosA - dy * sinA;
        const y = cy + dx * sinA + dy * cosA;
        this.ctx.beginPath();
        this.ctx.ellipse(Math.floor(x), Math.floor(y + 1), 3, 3, 0, 0, 2 * Math.PI);
        this.ctx.fill();
        if (index >= 0) {
            this.spaceItems[index].style.top = y - 18 + 'px';
            this.spaceItems[index].style.left = x + 'px';
            $(this.spaceItems[index]).addClass('ready');
        }
    },
}

/** MapGrid **/
MapGrid = function(selector) {
    this.mapGrid = document.querySelector(selector);
    this.mapGridItems = Array.prototype.slice.call(document.querySelectorAll(selector + ' .article-item'));
    this.fullGridItems = Array.prototype.slice.call(document.querySelectorAll(selector + ' .article-full-item'));
    this.groupedGridItems = {start: [], end: []};
    for (let i = 0; i <= 10; i++) {
        this.groupedGridItems.start[i] = [];
        this.groupedGridItems.end[i] = [];
    }
    this.mapGridItems.forEach(item => {
        this.groupedGridItems.start[item.dataset.start - 1].push(item);
        this.groupedGridItems.end[item.dataset.end - 1].push(item);
    });
    if (mainIndex != 0) {
        this.groupedGridItems.start = loopArray(this.groupedGridItems.start, false, mainIndex);
        this.groupedGridItems.end = loopArray(this.groupedGridItems.end, false, mainIndex);
    }
    this.init();
}
MapGrid.prototype = {
    init: function() {
        this.mapGrid.style.top = Math.floor(sphere.moveY - sphere.radius/2) + 'px';
        this.draw();
    },
    draw: function(animated = false, positiv = true) {
        for (let i = 0; i <= 10; i++) {
            // reset all items to collection column
            this.groupedGridItems.start[i].forEach(item => {
                item.dataset.classList = 'article-item';
                item.dataset.left = '-1';
                item.dataset.right = '-1';
                if (item.dataset.start <= mainIndex && item.dataset.end > mainIndex) {
                    item.dataset.classList = 'article-item inCollection';
                    item.dataset.left = '1';
                }
            });
        }

        this.fullGridItems.forEach( item => { // Beschaffungswesen
            item.classList = 'article-full-item inCollection';
            item.dataset.left = '1';
            item.dataset.right = '-1';
            this.drawSVG(item);
        });

        this.groupedGridItems.start[0].forEach(item => { // left section1
            item.dataset.classList  = 'article-item inCollection start';
            item.dataset.left = sections.section1;
        });
        this.groupedGridItems.start[1].forEach(item => {// left section2
            item.dataset.classList  = 'article-item inMain start';
            item.dataset.left = sections.section2;
        });
        this.groupedGridItems.start[2].forEach(item => {// left sectionHalf
            item.dataset.classList  = 'article-item inNext start';
            item.dataset.left = sections.sectionHalf;
            if (positiv && animated) { // animation from right to left into the view
                item.dataset.classList  += ' rightOffToNext'
            }
        });
        if (!positiv && animated) {
            this.groupedGridItems.start[3].forEach(item => {
                // animation from left to right out of the view
                item.dataset.classList  = 'article-item nextToRightOff';
            });
        }

        this.groupedGridItems.end[0].forEach(item => {// right section3
            item.dataset.classList += ' toCollection end';
            item.dataset.right = sections.section2;
        })
        this.groupedGridItems.end[1].forEach(item => {// right sectionHalf
            item.dataset.classList  += ' toMain end';
            item.dataset.right = sections.sectionHalf;
        })
        this.groupedGridItems.end[2].forEach(item => {// right section1
            item.dataset.classList  += ' toNext end';
            item.dataset.right = sections.section3;
        });
        this.groupedGridItems.end[3].forEach(item => { //100px
            item.dataset.classList  += ' toLast end';
            item.dataset.right = sections.section4;
        });

        window.requestAnimationFrame(() => {
            this.mapGridItems.forEach( item => {
                // we add all classes at once - so we do not mess the css left animation
                item.classList = item.dataset.classList;
                item.dataset.classList = '';
                this.drawSVG(item, animated);
            });
            if (!animated) {
                $('#map-grid').addClass('animated');
            }
        })

    },
    drawSVG(item, animated = false) {
        /*
         * svg_tick and svg_tack for overlapping fade animation - they swap in each animation
         * svg_tick is drawn first - without animation
         */
        const svg_tick = $(item).find('.line.tick');
        const svg_tack = $(item).find('.line.tack');
        const svg = animated ? svg_tack : svg_tick;

        if (svg && item.dataset.left > 0) {

            const w = sphere.width;
            const h = 70;
            const center = Math.floor(sphere.radius + SPHERE_OFFSET);

            if (!$(svg).attr('viewBox') || !animated) { // on resize
                $(svg).attr("viewBox", "0 0 " + w + " " + h);
                $(svg).attr("class", $(svg).attr("class") + " h-auto w-full");
            }
            let head = this.initOrUpdateSVGNode(svg, 'head_' + item.id);
            let arrow = this.initOrUpdateSVGNode(svg, 'arrow_' + item.id)
            let tail = this.initOrUpdateSVGNode(svg, 'tail_' + item.id);

            const fullSphere = item.dataset.right === '-1';
            const eastSphere = fullSphere || item.dataset.right > center;
            const lastSphere = !fullSphere && item.dataset.right > center + sphere.longitudes[1];

            const Y = h - 20;
            const X1 = item.dataset.left > 1 ? parseInt(item.dataset.left, 10) :
                this.getInterSection(item.getBoundingClientRect().y, false);
            const X2 = eastSphere ? Math.max(X1, center) :
                parseInt(item.dataset.right);
            let X3 = item.dataset.right > 0 ? item.dataset.right :
                this.getInterSection(item.getBoundingClientRect().y, true);

            let arrowPath = this.getStartOfArrowPath(item, X1, X2, Y);

            if (eastSphere) { // draw arc-path on east-Sphere
                const rx = X3 - X2;
                let ry = 40;
                if (fullSphere) {
                    const XArrowHead = this.polarToCartesian(X2, Y, rx, ry, 0).x;
                    this.drawArrowHead(XArrowHead, head, svg);
                } else {
                    let Y3 = lastSphere ? Math.floor(2/3 * Y) : Math.floor(15/16 * Y);
                    ry = lastSphere ? 20 : 5;
                    this.drawCircle(X3, Y3, head, svg, true);
                }
                arrowPath += this.describeArc(X2, Y, rx, ry, true);
            } else {
                arrowPath += ['L', X3, Y].join(' ');
                this.drawCircle(X3 , Y, head, svg, true);
            }

            if (item.dataset.left > 1) { // start point
                this.drawCircle(X1, Y, tail, svg, false);
            } else {
                tail.remove();
            }

            this.drawArrow(arrowPath, arrow, svg);
            if (animated) {
                svg_tick.removeClass('tick').addClass('tack');
                svg.removeClass('tack').addClass('tick');
            }
        } else {
            $(svg_tick).empty();
            $(svg_tack).empty();
        }
    },

    /** helpers  drawSVG **/
    initOrUpdateSVGNode(svg, id) {
        let node = $(svg).find('#' + id)[0];
        if (!node) {
            node = document.createElementNS("http://www.w3.org/2000/svg", "path");
            node.setAttribute('id', id);
        }
        return node;
    },
    getInterSection(y, eastSphere) {
        let yOffset = $('#sphere')[0].getBoundingClientRect().y // 95 = 55px headerHeight + 40px padding top
        yOffset += eastSphere ? 30 : 0 // left and right side of arc are not on same y-value
        const yTranslatedOnSphere = y - sphere.moveY - yOffset;
        const alpha = Math.acos(yTranslatedOnSphere / sphere.radius);
        const x = Math.round(sphere.radius * Math.sin(alpha)); // translate back from negative section
        return eastSphere ? sphere.moveX + x : sphere.moveX - x;
    },
    getStartOfArrowPath(item, X1, X2, Y) {
        if (item.dataset.left === '1') { // begin of arrow as ellipse
            const rx = sections.section2 - X1;
            const ry = 20;
            return  this.describeArc(parseInt(sections.section2, 10), Y, rx, ry, false) +
                [" L", X2, Y].join(" ");
        } else {
            return [
                "M", X1, Y,
                "L", X2, Y
            ].join(" ");
        }
    },
    drawArrow(path, element, svg) {
        element.setAttribute("d", path);
        element.setAttribute("stroke", ethGray40);
        element.setAttribute('stroke-width', '1px');
        element.setAttribute("fill", "none");
        $(svg).append(element);
    },
    drawCircle(x, y, element, svg, eastSphere) {
        // circle with radius 3px
        const moveX = eastSphere ? '-6' : '0';
        const path = [
            "M", x, y,
            "m", moveX, "0",
            "a", "3,3 0 1,0 6,0",
            "a", "3,3 0 1,0 -6,0"
        ].join(" ");
        element.setAttribute("d", path);
        element.setAttribute("fill", ethGray40);
        element.setAttribute('transform', 'translate(0,0)');
        $(svg).append(element);
    },
    drawArrowHead(start, element, svg) {
        const path = [
            'M', start, '0',
            'l', '-10,4',
            'c', '4 1 5 3', '6,6' + ' Z'
        ].join(" ");
        element.setAttribute("fill", ethGray40);
        element.setAttribute("d",  path);
        element.setAttribute('transform', 'translate(0,10)');
        $(svg).append(element);
    },
    drawLine(svg, id, x1, x2, y) { // only for testing !!!
        const path = [
            "M", x1, y,
            "L", x2, y
        ].join(" ");
        const line = this.initOrUpdateSVGNode(svg, id);
        line.setAttribute("d", path);
        line.setAttribute("stroke", '#909000');
        line.setAttribute('stroke-width', '1px');
        line.setAttribute("fill", "none");
        $(svg).append(line);
    },
    describeArc(x, y, rx, ry, eastSphere) {
        let startAngle = Math.PI/2;
        let endAngle = -Math.PI/1000; // near zero
        if (!eastSphere) {
            startAngle = Math.PI - Math.PI / 1000;// near 180 deg
            endAngle = Math.PI/2;
        }
        let start = this.polarToCartesian(x, y, rx, ry, startAngle);
        let end = this.polarToCartesian(x, y, rx, ry, endAngle);
        let translateY = eastSphere ? start.y - y : end.y - y;
        return [
            "M", start.x, start.y - translateY,
            "A", rx, ry, 0, 0, 0, end.x, end.y - translateY
        ].join(" ");
    },
    polarToCartesian(centerX, centerY, radiusX, radiusY, alpha) {
        return {
            x: Math.round(centerX + radiusX * Math.cos(alpha)),
            y: Math.round(centerY + radiusY * Math.sin(alpha))
        };
    },
    /** other helpers **/
    loop: function(positiv) {
        this.groupedGridItems.start = loopArray(this.groupedGridItems.start, positiv);
        this.groupedGridItems.end = loopArray(this.groupedGridItems.end, positiv);
    },
    animate(direction) {
        this.draw(true, direction);
    }
 }
